module.exports = __webpack_public_path__ + "static/logo-1b70d059f6463b2ff4f3bb4342589ac3.svg";